import React, { useEffect, useState, Suspense } from "react";
import { motion } from "framer-motion";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import responsive from "../Components/Responsive";
import Loading from "../Components/Loading";
import filmicon from "../assets/image/film-slate.png";
import televisonicon from "../assets/image/television.png";
import peopleicon from "../assets/image/guest-star.png";
import threedglass from "../assets/image/3d-glasses.png";
import topmovicon from "../assets/image/movie.png";
import live from "../assets/image/live.png";
import besttv from "../assets/image/quiz.png";
import camera from "../assets/image/filmcamera.png";
import tv from "../assets/image/tvtwo.png";
import Loader from "../Components/Loader";
import Background from "../Components/Background";
import apiService from "../api/apiservice";
const MovieCard = React.lazy(() => import("../Components/MovieCard"));

const CategoryPage = () => {
  const [toptvdata, settoptvdata] = useState([]);
  const [onairdata, setonairdata] = useState([]);
  const [popularmoviedata, setpopularmoviedata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cardData, setCardData] = useState([]);
  const [cardDatatwo, setCardDatatwo] = useState([]);
  const [coming, setcoming] = useState([]);
  const [tvtrend, settvtrend] = useState([]);
  const [topmovdata, settopmovdata] = useState([]);
  const [topindianmov, settopindiamov] = useState([]);
  const [topindiantv, settopindiantv] = useState([]);

  const newDate = new Date();
  const date = newDate.getDate();
  const month = newDate.getMonth() + 1;
  const year = newDate.getFullYear();

  // Fetch functions using apiService
  const fetchAllData = async () => {
    setLoading(true);
    try {
      const [
        topRatedTV,
        tvAiringToday,
        topRatedMovies,
        popularMovies,
        trendingTV,
        trendingMovies,
        trendingAll,
        trendingPeople,
        topIndianMovies,
        topIndianTV,
      ] = await Promise.all([
        apiService.getTopRatedTV(),
        apiService.getTVAiringToday(),
        apiService.getTopRatedMovies(),
        apiService.getPopularMovies(),
        apiService.getTrendingTV(),
        apiService.getTrendingMovies(),
        apiService.getTrendingAll(),
        apiService.getTrendingPeople(),
        apiService.getTopIndianMovies(year, month, date),
        apiService.getTopIndianTV(year, month, date),
      ]);

      settoptvdata(topRatedTV);
      setonairdata(tvAiringToday);
      settopmovdata(topRatedMovies);
      setpopularmoviedata(popularMovies);
      settvtrend(trendingTV);
      setcoming(trendingMovies);
      setCardData(trendingAll);
      setCardDatatwo(trendingPeople);
      settopindiamov(topIndianMovies);
      settopindiantv(topIndianTV);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  return (
    <Suspense fallback={<Loader />}>
      {cardData.length > 0 ? (
        <div className="">
          {loading ? (
            <>
              <Loader />
              <Background />
            </>
          ) : (
            <div className="">
              <div className=" bg-yellow-900 p-2 md:p-5 rounded-md bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-10 border my-4 border-gray-700">
                <div className="newfont relative md:d-none capitalize z-30  mx-5 text-center text-transparent bg-gradient-to-r from-slate-200/90 to-slate-400/90 bg-clip-text font-extrabold text-lg md:text-xl lg:text-2xl 2xl:text-3xl ">
                  Explore what’s trending in film right now
                </div>
              </div>
              <div className="my-6">
                {/* HOT RIGHT NOW */}
                {cardData.length > 0 && (
                  <div>
                    <div className="flex flex-row z-40 relative items-center">
                      <h4 className="newfont text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text font-extrabold ml-4 mr-2">
                        HOT RIGHT NOW
                      </h4>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        className="size-4 z-40 fill-red-600 animate-pulse"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8.074.945A4.993 4.993 0 0 0 6 5v.032c.004.6.114 1.176.311 1.709.16.428-.204.91-.61.7a5.023 5.023 0 0 1-1.868-1.677c-.202-.304-.648-.363-.848-.058a6 6 0 1 0 8.017-1.901l-.004-.007a4.98 4.98 0 0 1-2.18-2.574c-.116-.31-.477-.472-.744-.28Zm.78 6.178a3.001 3.001 0 1 1-3.473 4.341c-.205-.365.215-.694.62-.59a4.008 4.008 0 0 0 1.873.03c.288-.065.413-.386.321-.666A3.997 3.997 0 0 1 8 8.999c0-.585.126-1.14.351-1.641a.42.42 0 0 1 .503-.235Z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <Carousel
                      responsive={responsive}
                      swipeable
                      draggable
                      showDots={false}
                      infinite
                      partialVisible={false}
                    >
                      {cardData.map((movie, i) => (
                        <motion.span
                          key={i}
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          viewport={{ once: true }}
                        >
                          <Suspense fallback={<Loading />}>
                            <MovieCard movie={movie} />
                          </Suspense>
                        </motion.span>
                      ))}
                    </Carousel>
                  </div>
                )}

                {/* TOP INDIAN MOVIE PICKS OF THE DAY */}
                {topindianmov.length > 0 && (
                  <div>
                    <div className="flex flex-row z-40 relative items-center">
                      <h4 className="newfont text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text font-extrabold ml-4 mr-2">
                        TOP INDIAN MOVIE PICKS OF THE DAY
                      </h4>
                      <img
                        src={camera}
                        alt="film-slate-icon"
                        className="animate-pulse w-[20px]"
                      />
                    </div>
                    <Carousel
                      responsive={responsive}
                      swipeable
                      draggable
                      showDots={false}
                      infinite
                      partialVisible={false}
                    >
                      {topindianmov.map((movie, i) => (
                        <motion.span
                          key={i}
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          viewport={{ once: true }}
                        >
                          <Suspense fallback={<Loading />}>
                            <MovieCard
                              movie={movie}
                              filterType={{ isMovieChecked: true }}
                            />
                          </Suspense>
                        </motion.span>
                      ))}
                    </Carousel>
                  </div>
                )}

                {/* TOP INDIAN TV PICKS OF THE DAY */}
                {topindiantv.length > 0 && (
                  <div>
                    <div className="flex flex-row z-40 relative items-center">
                      <h4 className="newfont text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text font-extrabold ml-4 mr-2">
                        TOP INDIAN TV PICKS OF THE DAY
                      </h4>
                      <img
                        src={tv}
                        alt="film-slate-icon"
                        className="animate-pulse w-[20px]"
                      />
                    </div>
                    <Carousel
                      responsive={responsive}
                      swipeable
                      draggable
                      showDots={false}
                      infinite
                      partialVisible={false}
                    >
                      {topindiantv.map((movie, i) => (
                        <motion.span
                          key={i}
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          viewport={{ once: true }}
                        >
                          <Suspense fallback={<Loading />}>
                            <MovieCard
                              movie={movie}
                              filterType={{ isTvChecked: true }}
                            />
                          </Suspense>
                        </motion.span>
                      ))}
                    </Carousel>
                  </div>
                )}

                {/* What’s On TV */}
                {tvtrend.length > 0 && (
                  <div>
                    <div className="flex flex-row z-40 relative items-center">
                      <h4 className="newfont text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text font-extrabold ml-4 mr-2">
                        What’s On TV
                      </h4>
                      <img
                        src={televisonicon}
                        alt="film-slate-icon"
                        className="animate-pulse w-[20px]"
                      />
                    </div>
                    <Carousel
                      responsive={responsive}
                      swipeable
                      draggable
                      showDots={false}
                      infinite
                      partialVisible={false}
                    >
                      {tvtrend.map((movie, i) => (
                        <motion.span
                          key={i}
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          viewport={{ once: true }}
                        >
                          <Suspense fallback={<Loading />}>
                            <MovieCard
                              movie={movie}
                              filterType={{ isTvChecked: true }}
                            />
                          </Suspense>
                        </motion.span>
                      ))}
                    </Carousel>
                  </div>
                )}

                {/* MOVIES OF THE DAY */}
                {coming.length > 0 && (
                  <div>
                    <div className="flex flex-row z-40 relative items-center">
                      <h4 className="newfont text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text font-extrabold ml-4 mr-2">
                        MOVIES OF THE DAY
                      </h4>
                      <img
                        src={filmicon}
                        alt="film-slate-icon"
                        className="animate-pulse w-[20px]"
                      />
                    </div>
                    <Carousel
                      responsive={responsive}
                      swipeable
                      draggable
                      showDots={false}
                      infinite
                      partialVisible={false}
                    >
                      {coming.map((movie, i) => (
                        <motion.span
                          key={i}
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          viewport={{ once: true }}
                        >
                          <Suspense fallback={<Loading />}>
                            <MovieCard
                              movie={movie}
                              filterType={{ isMovieChecked: true }}
                            />
                          </Suspense>
                        </motion.span>
                      ))}
                    </Carousel>
                  </div>
                )}

                {/* POPULAR MOVIES */}
                {popularmoviedata.length > 0 && (
                  <div>
                    <div className="relative z-40 flex flex-row justify-between w-max items-center">
                      <h4 className="newfont text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text font-extrabold ml-4 mr-2">
                        POPULAR MOVIES
                      </h4>
                      <img
                        src={threedglass}
                        alt="film-slate-icon"
                        className="animate-pulse w-[20px]"
                      />
                    </div>
                    <Carousel
                      responsive={responsive}
                      swipeable
                      draggable
                      showDots={false}
                      infinite
                      partialVisible={false}
                    >
                      {popularmoviedata.map((movie) => (
                        <MovieCard
                          movie={movie}
                          filterType={{ isMovieChecked: true }}
                        />
                      ))}
                    </Carousel>
                  </div>
                )}

                {/* TOP RATED MOVIES */}
                {topmovdata.length > 0 && (
                  <div>
                    <div className="relative z-40 flex flex-row justify-between w-max items-center">
                      <h4 className="newfont text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text font-extrabold ml-4 mr-2">
                        TOP RATED MOVIES
                      </h4>
                      <img
                        src={topmovicon}
                        alt="film-slate-icon"
                        className="animate-pulse w-[20px]"
                      />
                    </div>
                    <Carousel
                      responsive={responsive}
                      swipeable
                      draggable
                      showDots={false}
                      infinite
                      partialVisible={false}
                    >
                      {topmovdata.map((movie) => (
                        <MovieCard
                          movie={movie}
                          filterType={{ isMovieChecked: true }}
                        />
                      ))}
                    </Carousel>
                  </div>
                )}

                {/* ON AIR TODAY */}
                {onairdata.length > 0 && (
                  <div>
                    <div className="flex flex-row z-40 relative items-center">
                      <h4 className="newfont text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text font-extrabold ml-4 mr-2">
                        ON AIR TODAY
                      </h4>
                      <img
                        src={live}
                        alt="film-slate-icon"
                        className="animate-pulse w-[20px]"
                      />
                    </div>
                    <Carousel
                      responsive={responsive}
                      swipeable
                      draggable
                      showDots={false}
                      infinite
                      partialVisible={false}
                    >
                      {onairdata.map((movie, i) => (
                        <motion.span
                          key={i}
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          viewport={{ once: true }}
                        >
                          <Suspense fallback={<Loading />}>
                            <MovieCard
                              movie={movie}
                              filterType={{ isTvChecked: true }}
                            />
                          </Suspense>
                        </motion.span>
                      ))}
                    </Carousel>
                  </div>
                )}

                {/* TOP RATED TV */}
                {toptvdata.length > 0 && (
                  <div>
                    <div className="flex flex-row z-40 relative items-center">
                      <h4 className="newfont text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text font-extrabold ml-4 mr-2">
                        TOP RATED TV
                      </h4>
                      <img
                        src={besttv}
                        alt="film-slate-icon"
                        className="animate-pulse w-[20px]"
                      />
                    </div>
                    <Carousel
                      responsive={responsive}
                      swipeable
                      draggable
                      showDots={false}
                      infinite
                      partialVisible={false}
                    >
                      {toptvdata.map((movie, i) => (
                        <motion.span
                          key={i}
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          viewport={{ once: true }}
                        >
                          <Suspense fallback={<Loading />}>
                            <MovieCard
                              movie={movie}
                              filterType={{ isTvChecked: true }}
                            />
                          </Suspense>
                        </motion.span>
                      ))}
                    </Carousel>
                  </div>
                )}

                {/* TALK OF THE TOWN */}
                {cardDatatwo.length > 0 && (
                  <div>
                    <div className="relative z-40 flex flex-row justify-between w-max items-center">
                      <h4 className="newfont text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text font-extrabold ml-4 mr-2">
                        TALK OF THE TOWN
                      </h4>
                      <img
                        src={peopleicon}
                        alt="film-slate-icon"
                        className="animate-pulse w-[20px]"
                      />
                    </div>
                    <Carousel
                      responsive={responsive}
                      swipeable
                      draggable
                      showDots={false}
                      infinite
                      partialVisible={false}
                    >
                      {cardDatatwo.map((movie) => (
                        <MovieCard movie={movie} filterType={{ isPersonChecked: true }} />
                      ))}
                    </Carousel>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      ) : null}
    </Suspense>
  );
};

export default CategoryPage;
